import React from 'react';

// ♀ and ♂ drawn as icons: the text characters come from a fallback font on
// iOS and sit below the chip's label. Same 24px grid and stroke as Heroicons.

interface IconProps {
  className?: string;
}

export const FemaleIcon = ({ className }: IconProps) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    aria-hidden='true'
  >
    <circle cx='12' cy='9' r='5.5' />
    <path d='M12 14.5V22M8.5 18.5h7' />
  </svg>
);

export const MaleIcon = ({ className }: IconProps) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    aria-hidden='true'
  >
    <circle cx='10' cy='14' r='5.5' />
    <path d='M14 10l7-7M15 3h6v6' />
  </svg>
);
